import { Col, Row, Dropdown, Button, Tooltip, OverlayTrigger, Card, Container } from "react-bootstrap";
import { FaEllipsisV, FaPlus } from "react-icons/fa";
import './Shelves.css'; // Custom CSS for additional styling
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import { useShelvePageList } from "../../../hooks/useShelvePageList";
import ToastrNotifi from "../../../Utilities/ToastrNotifi";
import { useSpinner } from "../../../Utilities/SpinnerContext";
import DeleteModel from '../../../Utilities/DeleteModal';
import './ShelvePageList.css';
import { useBreadcrumbs } from "../../../Utilities/Breadscrumb/BreadcrumbContext";
import GlobalSpinner from "../../../Utilities/GlobleSpinner";
import { useUpdateLastReads } from "../../../hooks/useGetLastReads";

const beURL = localStorage.getItem('BeURL');

export default function ShelvePageList() {
    const { showSpinner, hideSpinner } = useSpinner();
    const navigate = useNavigate();
    const location = useLocation();

    const [modalShow, setModalShow] = useState(false);
    const [deleteData, setDeleteData] = useState({});
    const [pagesData, setPageData] = useState([]);
    const [shelveData, setShelveData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage, setRowsPerPage] = useState(0);

    const { id, slug } = useParams();
    const { addBreadcrumb } = useBreadcrumbs();


    // Fetch paginated data
    const { data: pageList,
        isSuccess: isPageListSuccess,
        isError: isPageFetchError,
        error: pageListError,
        refetch, isFetched,
        isLoading: isPageListLoading,
        isFetching,
    } = useShelvePageList(false, id, page);


    // Error handling moved inside useEffect
    useEffect(() => {
        if (isPageFetchError) {
            ToastrNotifi.errorToast(pageListError.message);
            console.log(pageListError);
        }
    }, [isPageFetchError, pageListError]);



    // Handle pagination change
    const handlePageChange = (event, value) => {
        // console.log(value);
        setPage(value);
        console.log(value);
        console.log(page);
        refetch();
    };

    // Breadcrumb logic
    useEffect(() => {
        refetch();
        // setPage(pageList?.pages.current_page);
        addBreadcrumb(slug, location.pathname);
        return () => {
        };
    }, [addBreadcrumb, location.pathname, slug, page]);


    // Navigation functions
    const navigateToPage = (page_id, slug) => {
        navigate(`/page/content/${page_id}/${slug}`);
    };

    function addNewPage(shelve_ID, shelve_Name) {
        const parsingData = {
            shelve_id: shelve_ID,
            shelve_name: shelve_Name,
        };
        navigate(`/create/page/`, { state: parsingData });
    }

    function EditShelve(shelve_ID) {
        navigate(`/edit/shelve/`, { state: { shelve_ID: shelve_ID } });
    }

    function DeleteShelve(shelve_ID, Shelve_Name) {
        const data = { id: shelve_ID, name: Shelve_Name };
        setDeleteData(data);
        setModalShow(true);
    }

    if (isFetching) {
        return <GlobalSpinner />
    }

    return (
        <>
            <Container fluid>
                <Row className="pt-3 px-2">
                    <div className="d-flex justify-content-between px-2">
                        <div>
                            <h3>{pageList?.shelve.name}</h3>
                            <p>{pageList?.shelve.description}</p>
                        </div>
                        <div>
                            <div className="d-flex justify-content-around pe-5">
                                <OverlayTrigger

                                    placement="bottom"
                                    overlay={<Tooltip id="tooltip-bottom" className="custom-Tooltip-z">Add New Page to Shelve</Tooltip>}
                                >
                                    <Button variant="outline" className="mx-3" onClick={() => addNewPage(id, pageList?.shelve.name)}>
                                        <FaPlus />
                                    </Button>
                                </OverlayTrigger>

                                <Dropdown>
                                    <OverlayTrigger

                                        placement="top"
                                        overlay={<Tooltip id="tooltip-top" className="custom-Tooltip-z">More Options</Tooltip>}
                                    >
                                        <Dropdown.Toggle variant="outline" id="dropdown" className="no-arrow">
                                            <FaEllipsisV />
                                        </Dropdown.Toggle>
                                    </OverlayTrigger>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => EditShelve(id)}>Edit Shelve</Dropdown.Item>
                                        <Dropdown.Item onClick={() => DeleteShelve(id, pageList?.shelve.name)} className="text-danger">
                                            Delete Shelve
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                        </div>
                    </div>
                </Row>
            </Container>
            <Container>
                <Row className="mt-2">
                    <Col sm={12}>
                        <Card.Body>
                            {pageList?.pages.data.length === 0 ? (
                                <h4 className="text-center text-warning">No pages in this shelve</h4>
                            ) : (
                                <div className="page-container">
                                    {pageList?.pages.data.map((page) => (
                                        <Card
                                            key={page.id}
                                            className="mb-3 shadow-sm hover-shadow"
                                            onClick={() => navigateToPage(page.id, page.slug)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Card.Body>
                                                <h6 className="mb-0">{page.title}</h6>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            )}
                        </Card.Body>
                    </Col>
                    <div className="d-flex justify-content-center">
                        <Pagination
                            count={pageList?.pages.last_page}  // Total number of pages
                            page={page}         // Current page
                            onChange={handlePageChange}
                            color="primary"
                            size="large"
                        />
                    </div>
                </Row>

                <DeleteModel
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    deleteData={deleteData}
                    deleteBeUrl={`${beURL}delete/shelve/${deleteData.id}`}
                    AfterDeleteNavigate={-1}
                    ToastrMessage={"Shelve deleted successfully!"}
                    ModelHeader={"Are you sure you want to delete this Shelve? This action cannot be undone."}
                    SubHeader={"This Shelve and all pages under it will be deleted."}
                />
            </Container>
        </>
    );
}
